import { gql } from "apollo-boost";

export const ContentfulBannerInfo = gql`
  query ContentfulBannerInfo($deviceType: String!) {
    getBanners(deviceType: $deviceType) {
      banners {
        id
        title
        body
        primaryButton
        primaryButtonPath
        image
      }
    }
  }
`;
